// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getNotifyStyle } from "@steiner/App/Components/Notify";
import { promotionCodeFormStyles } from "@steiner/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPromotionCode";
import MenuClose from "@steiner/XDL/Icons/MenuClose";
import { mergeWithCss, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

promotionCodeFormStyles.checkoutBoxStyles = {
    container: {
        css: css`
            height: 325px;
            ${xScreen("lte", "md")} {
                height: auto;
            }
        `,
    },
};

promotionCodeFormStyles.applyButton = {
    variant: "tertiary",
};

promotionCodeFormStyles.applySuccessText = {
    color: "success",
    size: "12px",
};

promotionCodeFormStyles.promotionCodeGridItem = {
    width: 12,
};

promotionCodeFormStyles.applyPromotionGridItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
    `,
};

promotionCodeFormStyles.applySuccessText = {
    ...mergeWithCss(getNotifyStyle("success"), {
        css: css`
            margin: 0;
        `,
    }),
};

promotionCodeFormStyles.removeCodesLink = {
    color: "danger",
    typographyProps: {
        size: 12,
    },
    icon: {
        iconProps: {
            src: MenuClose,
            size: 8,
            color: "danger",
        },
    },
};

promotionCodeFormStyles.removeCodeTag = {};
